import _objectSpread from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import elementEnLocale from 'element-ui/lib/locale/lang/en'; // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'; // element-ui lang
import elementTurkicLocale from 'element-ui/lib/locale/lang/en'; // element-ui lang
import enLocale from './en';
import zhLocale from './zh';
import turkicLocale from './tr';
console.log('zhLocale', zhLocale);
Vue.use(VueI18n);
var messages = {
  en: _objectSpread(_objectSpread({}, enLocale), elementEnLocale),
  zh: _objectSpread(_objectSpread({}, zhLocale), elementZhLocale),
  tr: _objectSpread(_objectSpread({}, turkicLocale), elementTurkicLocale)
};
var i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || 'zh',
  // set locale messages
  messages: messages,
  silentTranslationWarn: true
});
i18n['$t'] = function (key) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  console.log('i18n', key);
  var str = i18n.t(key);
  Object.keys(opt).forEach(function (k) {
    return str = str.replace("{".concat(k, "}"), opt[k]);
  });
  return str;
};
export default i18n;